import { ReactNode } from 'react';
import CssBaseline from '@mui/material/CssBaseline';
import Box from '@mui/material/Box';
import Toolbar from '@mui/material/Toolbar';

import secretaryRoutes from '../../setup/router/secretary/routes';
import doctorRoutes from '../../setup/router/doctor/routes';
import CustomSidebar from '../components/UI/CustomSidebar/CustomSidebar';
import Loader from '../components/UI/Loader/loader';
import { Roles } from '../../utils/roles';
import { useUserService } from '../hooks';

const drawerWidth = 240;

interface Props {
  children: ReactNode;
}

const SidebarLayout = ({ children }: Props) => {
  const UserService = useUserService();

  let routes;
  if (UserService.hasRole(Roles.secretary)) routes = secretaryRoutes;
  else if (UserService.hasRole(Roles.doctor)) routes = doctorRoutes;

  if (routes == null) return <div />;

  return (
    <Box sx={{ display: 'flex' }}>
      <CssBaseline />
      <CustomSidebar routes={routes} drawerWidth={drawerWidth} />
      <Box
        component='main'
        sx={{
          flexGrow: 1,
          padding: { xs: '24px 12px', sm: '24px' },
          width: { sm: `calc(100% - ${drawerWidth}px)` },
          maxWidth: '100%'
        }}
      >
        <Toolbar sx={{ display: { md: 'none' } }} />
        {children}
      </Box>
      <Loader />
    </Box>
  );
};

export default SidebarLayout;
